import { commonUtil } from '@/util'
const request = {}

request.createRequest = function ({
  searchDetailInfo,
  searchHeaderInfo,
  page
}) {
  return {
    shipStartDate: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line1.shipDate.start
    ),
    shipEndDate: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line1.shipDate.end
    ),
    customerIds: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line1.customerName
        .map((customerName) => {
          return customerName.value
        })
        .join(',')
    ),
    storageId: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line1.shipStorage.value
    ),
    status: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line1.shipStatus?.value
    ),
    saleControlNumber: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line2.saleInfo.saleNumber
    ),
    shipControlNumber: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line2.saleInfo.remittanceNumber
    ),
    productNumber: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line2.productInfo.number
    ),
    productName: commonUtil.nullEmptyFormatNull(searchHeaderInfo.productName),
    productCategoryId: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line2.productInfo.category.value
    ),
    invalidShipDisplay: searchHeaderInfo.InvalidData ? 0 : 1,
    page: commonUtil.nullEmptyFormatNull(page)
  }
}
export default { request }
